import styled from 'styled-components'

export const LinkContainer = styled.div`
  margin-right: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
`
